import { Stack, Typography } from '@mui/material';

import { SocialShareStatInfo } from 'api/services';
import DetailCard from 'components/DetailCard';
import React from 'react';
import Stat from './Stat';

type SocialStatsSummaryProps = {
  stats: Omit<SocialShareStatInfo, 'isViewCountStale'>;
  title?: string;
};

const SocialStatsSummary: React.FC<SocialStatsSummaryProps> = ({
  stats,
  title,
}) => {
  const width = '33.3%';

  return (
    <Stack width="100%" spacing="8px">
      <Typography variant="h3">{title}</Typography>
      <DetailCard>
        <Stat numberOf={stats.viewCount} statsType="views" width={width} />

        <Stat numberOf={stats.likeCount} statsType="likes" width={width} />

        <Stat
          numberOf={stats.commentCount}
          statsType="comments"
          width={width}
        />
      </DetailCard>
    </Stack>
  );
};

export default SocialStatsSummary;
